import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "R3bLUcRURegistration" })
export default class R3bLUcRURegistration extends Vue {
    public localizer: any = Localizer;
    public isSuccess: boolean = false;
    public isLoading: boolean = false;
    public isAdult: boolean = true;
    public isCompanions: boolean = false;
    public isCompanionEdit: boolean = false;
    public isMotorhome: boolean = false;
    public countries: any = {};

    // public documentPictureFront: any = null;
    // public documentPictureRear: any = null;
    // public guardianDocumentPictureFront: any = null;
    // public guardianDocumentPictureRear: any = null;

    public profile: any = {
        country: null,
        helmetSize: null,
        leatherSuitSize: null,
        airbagJacketSize: null,
        bootsSize: null,
        glovesSize: null,
        documentType: null,
        guardianDocumentType: null
    };

    public companions: any[] = [];

    public companion: any = {
        country: null
    };

    public validationErrors: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly culture: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.countries = (await Axios.post(this.routes.Landing_R3bLUcRU_GetCountries, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    }

    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public checkLegalAge() {
        let today = new Date();
        let birthDate = new Date(this.profile.birthDate);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        age >= 18 ? this.isAdult = true : this.isAdult = false;
    }

    public setCompanionEdit() {
        this.isCompanionEdit = true;
    }

    public pushCompanion() {
        this.isLoading = true;
        this.validationErrors = [];

        let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!this.companion.name) {
            this.validationErrors.push({ name: "CompanionName", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionName_Required", this.culture) });
        } else if (this.companion.name.length > 99) {
            this.validationErrors.push({ name: "CompanionName", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionName_NotValid", this.culture) });
        }

        if (!this.companion.surname) {
            this.validationErrors.push({ name: "CompanionSurname", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionSurname_Required", this.culture) });
        } else if (this.companion.surname.length > 99) {
            this.validationErrors.push({ name: "CompanionSurname", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionSurname_NotValid", this.culture) });
        }

        if (!this.companion.phone) {
            this.validationErrors.push({ name: "CompanionPhone", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionPhone_Required", this.culture) });
        } else if (this.companion.phone.length > 20) {
            this.validationErrors.push({ name: "CompanionPhone", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionPhone_NotValid", this.culture) });
        }

        if (!this.companion.email) {
            this.validationErrors.push({ name: "CompanionEmail", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionEmail_Required", this.culture) });
        } else {
            if (!emailRegex.test(this.companion.email)) {
                this.validationErrors.push({ name: "CompanionEmail", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionEmail_NotValid", this.culture) });
            }

            if (this.companion.email.length > 255) {
                this.validationErrors.push({ name: "CompanionEmail", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionEmail_NotValid", this.culture) });
            }

            if (this.profile.email === this.companion.email) {
                this.validationErrors.push({ name: "CompanionEmail", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionEmail_NotValid", this.culture) });
            }

            if (this.companions.find(x => x.email === this.companion.email)) {
                this.validationErrors.push({ name: "CompanionEmail", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionEmail_NotValid", this.culture) });
            }
        }

        if (!this.companion.address) {
            this.validationErrors.push({ name: "CompanionAddress", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionAddress_Required", this.culture) });
        } else if (this.companion.address.length > 100) {
            this.validationErrors.push({ name: "CompanionAddress", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionAddress_NotValid", this.culture) });
        }

        if (!this.companion.city) {
            this.validationErrors.push({ name: "CompanionCity", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionCity_Required", this.culture) });
        } else if (this.companion.city.length > 100) {
            this.validationErrors.push({ name: "CompanionCity", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionCity_NotValid", this.culture) });
        }

        if (!this.companion.postCode) {
            this.validationErrors.push({ name: "CompanionPostCode", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionPostCode_Required", this.culture) });
        } else if (this.companion.postCode.length > 20) {
            this.validationErrors.push({ name: "CompanionPostCode", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionPostCode_NotValid", this.culture) });
        }

        if (!this.companion.country) {
            this.validationErrors.push({ name: "CompanionCountry", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionCountry_Required", this.culture) });
        }

        if (!this.companion.birthDate) {
            this.validationErrors.push({ name: "CompanionBirthDate", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionBirthDate_Required", this.culture) });
        }

        if (!this.companion.birthCountry) {
            this.validationErrors.push({ name: "CompanionBirthCountry", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionBirthCountry_Required", this.culture) });
        } else if (this.companion.birthCountry.length > 100) {
            this.validationErrors.push({ name: "CompanionBirthCountry", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionBirthCountry_NotValid", this.culture) });
        }

        if (!this.companion.documentType) {
            this.validationErrors.push({ name: "CompanionDocumentType", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionDocumentType_Required", this.culture) });
        }

        if (!this.companion.documentNumber) {
            this.validationErrors.push({ name: "CompanionDocumentNumber", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionDocumentNumber_Required", this.culture) });
        } else if (this.companion.documentNumber.length > 50) {
            this.validationErrors.push({ name: "CompanionDocumentNumber", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_CompanionDocumentNumber_NotValid", this.culture) });
        }

        if (this.companions.length < 3 && this.validationErrors.length === 0) {
            if (this.companion.name && this.companion.surname) {
                this.companions.push(this.companion);
                this.companion = {};

                this.validationErrors = [];
                this.isCompanionEdit = false;
            }
        }

        this.isLoading = false;
    }

    public async submitForm() {
        FormHelper.removeFocus();

        this.validationErrors = [];
        this.isLoading = true;

        // if (!this.documentPictureFront) {
        //     this.validationErrors.push({ name: "DocumentPictureFront", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_DocumentPictureFront_Required", this.culture) });
        // }

        // if (!this.documentPictureRear) {
        //     this.validationErrors.push({ name: "DocumentPictureRear", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_DocumentPictureRear_Required", this.culture) });
        // }

        // if (!this.isAdult) {
        //     if (!this.guardianDocumentPictureFront) {
        //         this.validationErrors.push({ name: "GuardianDocumentPictureFront", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_GuardianDocumentPictureFront_Required", this.culture) });
        //     }

        //     if (!this.guardianDocumentPictureRear) {
        //         this.validationErrors.push({ name: "GuardianDocumentPictureRear", message: this.localizer.getByCulture("Landing_R3bLUcRU.Common.ErrorMessage_GuardianDocumentPictureRear_Required", this.culture) });
        //     }
        // }

        if (this.validationErrors.length === 0) {
            try {
                this.profile.companions = JSON.stringify(this.companions);

                let response = (await Axios.post(this.routes.Landing_R3bLUcRU_SetProfile, this.profile, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } })).data;

                this.profile.idMaster = response;

                // if (this.documentPictureFront) {
                //     await this.saveDocumentImage(this.documentPictureFront, "Rider_Front_" + this.profile.idMaster);
                // }

                // if (this.documentPictureRear) {
                //     await this.saveDocumentImage(this.documentPictureRear, "Rider_Rear_" + this.profile.idMaster);
                // }

                // if (this.guardianDocumentPictureFront) {
                //     await this.saveDocumentImage(this.guardianDocumentPictureFront, "Guardian_Front_" + this.profile.idMaster);
                // }

                // if (this.guardianDocumentPictureRear) {
                //     await this.saveDocumentImage(this.guardianDocumentPictureRear, "Guardian_Rear_" + this.profile.idMaster);
                // }

                if (this.validationErrors.length === 0) {
                    this.isSuccess = true;
                }
            } catch (error) {
                if (error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }

                (<any>window).grecaptcha.reset();
            }
        }

        this.isLoading = false;
    }

    public yamahaRacing() {
        (<any>window).location = "https://www.yamaha-racing.com/";
    }

    public setPrivacyStatement() {
        let privacyStatement = "https://www.yamaha-motor.eu/gb/en/privacy-policy/";

        switch (this.culture) {
            case "es-ES":
                privacyStatement = "https://www.yamaha-motor.eu/es/es/privacy-policy/";
                break;
            case "fr-FR":
                privacyStatement = "https://www.yamaha-motor.eu/fr/fr/privacy-policy/";
                break;
            case "it-IT":
                privacyStatement = "https://www.yamaha-motor.eu/it/it/privacy/privacy-policy/";
                break;
            case "de-DE":
                privacyStatement = "https://www.yamaha-motor.eu/de/de/privacy-policy/";
                break;
            case "nl-NL":
                privacyStatement = "https://www.yamaha-motor.eu/nl/nl/privacy-policy/";
                break;
            case "pt-PT":
                privacyStatement = "https://www.yamaha-motor.eu/pt/pt/privacy-policy/";
                break;
        }

        return privacyStatement;
    }

    public setTermsAndCondition() {
        let termsAndCondition = "https://www.yamaha-racing.com/content/dam/yme-racing/eu/pdf/r3championship/2025/Terms-UK.pdf";

        switch (this.culture) {
            case "es-ES":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/yme-racing/eu/pdf/r3championship/2025/Terms-ES.pdf";
                break;
            case "fr-FR":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/yme-racing/eu/pdf/r3championship/2025/Terms-FR.pdf";
                break;
            case "it-IT":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/yme-racing/eu/pdf/r3championship/2025/Terms-IT.pdf";
                break;
            case "de-DE":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/yme-racing/eu/pdf/r3championship/2025/Terms-DE.pdf";
                break;
            case "nl-NL":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/yme-racing/eu/pdf/r3championship/2025/Terms-NL.pdf";
                break;
            case "pt-PT":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/yme-racing/eu/pdf/r3championship/2025/Terms-PT.pdf";
                break;
        }

        return termsAndCondition;
    }

    // public setDocumentPictureFront(event: any) {
    //     if (event.target.files.length != 0) {
    //         this.documentPictureFront = event.target.files[0];
    //     } else {
    //         this.documentPictureFront = null;
    //     }
    // }

    // public setDocumentPictureRear(event: any) {
    //     if (event.target.files.length != 0) {
    //         this.documentPictureRear = event.target.files[0];
    //     } else {
    //         this.documentPictureRear = null;
    //     }
    // }

    // public setGuardianDocumentPictureFront(event: any) {
    //     if (event.target.files.length != 0) {
    //         this.guardianDocumentPictureFront = event.target.files[0];
    //     } else {
    //         this.guardianDocumentPictureFront = null;
    //     }
    // }

    // public setGuardianDocumentPictureRear(event: any) {
    //     if (event.target.files.length != 0) {
    //         this.guardianDocumentPictureRear = event.target.files[0];
    //     } else {
    //         this.guardianDocumentPictureRear = null;
    //     }
    // }

    // public async saveDocumentImage(inputFile: any, fileName: string) {
    //     this.validationErrors = [];

    //     let formData = new FormData();
    //     formData.append("ProfileIdMaster", this.profile.idMaster);
    //     formData.append("FileName", fileName);
    //     formData.append("InputFile", inputFile);

    //     try {
    //         await Axios.post(this.routes.Landing_R3bLUcRU_SetDocumentPicture, formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });
    //     } catch (error) {
    //         if (error.response && error.response.status === 400) {
    //             this.validationErrors = FormHelper.getValidationErrors(error.response.data);
    //         }
    //     }
    // }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};